<template>
  <v-card color="borderInner" elevation="0" rounded="0" style="min-width: 100%; width: 100%; max-width: 100%; min-height: 100vh;">
    <div v-if="loader.selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView || loader.generateCRMWhatsappConversationFeedback" style="min-width: 100%; width: 100%; max-width: 100%; min-height: 100vh; height: 100vh; max-height: 100vh; display: flex; justify-content: center; align-items: center;">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else>
      <div v-if="navigation.CRMWhatsappConversationFeedbackGenerated" style="min-width: 100vw; min-height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; cursor: default; user-select: none; padding: 40px 40px;">
        <div>
          <div style="text-align: center;">
            <h1 style="margin-bottom: 10px;">¡Gracias por tu feedback!</h1>
            <p>Nuestro equipo de atención al cliente ha recibido tu feedback y estará atento a tus sugerencias y recomendaciones</p>
          </div>
          <v-divider style="margin-top: 40px; margin-bottom: 20px; width: 100%;"></v-divider>
          <p style="font-size: x-small;">Desarrollado por <strong>Souq Systems</strong></p>
          <img 
            :src="require('@/assets/images/KingVapeLogo.png')" 
            alt="King Vape" 
            draggable="false" 
            style="width: 100px; height: auto; margin-top: 5px;"
            :style="theme.global.name.value == 'dark' ? 'filter: invert(1);' : ''"
          >
          <div style="display: flex; justify-content: center; align-items: center; gap: 10px; margin-top: 10px;">
            <a href="https://kingvapecr.com" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/webLogo.png')" alt="Web" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://wa.me/50683545548" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/whatsappLogo.png')" alt="WhatsApp" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.instagram.com/thekingscr_" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/instagramLogo.png')" alt="Instagram" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.tiktok.com/@kingvape_cr" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/tiktokLogo.png')" alt="TikTok" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.youtube.com/@KingVapeCR" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/youtubeLogo.png')" alt="Youtube" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.facebook.com/profile.php?id=100056583533596&locale=es_LA" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/facebookLogo.png')" alt="Facebook" draggable="false" style="width: 25px; height: auto;"></a>
          </div>
        </div>
      </div>
      <div v-else-if="navigation.CRMWhatsappConversationError" style="min-width: 100vw; min-height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; cursor: default; user-select: none; padding: 40px 40px;">
        <div>
          <div style="text-align: center;">
            <h1 style="margin-bottom: 10px;">¡Lo sentimos!</h1>
            <p>La conversación no se encuentra disponible para compartir feedback en este momento</p>
          </div>
          <v-divider style="margin-top: 40px; margin-bottom: 20px; width: 100%;"></v-divider>
          <p style="font-size: x-small;">Desarrollado por <strong>Souq Systems</strong></p>
          <img 
            :src="require('@/assets/images/KingVapeLogo.png')" 
            alt="King Vape" 
            draggable="false" 
            style="width: 100px; height: auto; margin-top: 5px;"
            :style="theme.global.name.value == 'dark' ? 'filter: invert(1);' : ''"
          >
          <div style="display: flex; justify-content: center; align-items: center; gap: 10px; margin-top: 10px;">
            <a href="https://kingvapecr.com" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/webLogo.png')" alt="Web" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://wa.me/50683545548" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/whatsappLogo.png')" alt="WhatsApp" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.instagram.com/thekingscr_" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/instagramLogo.png')" alt="Instagram" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.tiktok.com/@kingvape_cr" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/tiktokLogo.png')" alt="TikTok" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.youtube.com/@KingVapeCR" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/youtubeLogo.png')" alt="Youtube" draggable="false" style="width: 25px; height: auto;"></a>
            <a href="https://www.facebook.com/profile.php?id=100056583533596&locale=es_LA" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/facebookLogo.png')" alt="Facebook" draggable="false" style="width: 25px; height: auto;"></a>
          </div>
        </div>
      </div>
      <div v-else style="min-height: 100%; text-align: center; padding: 40px 15px; cursor: default; user-select: none;">
        <h1 style="margin-bottom: 40px;">¡Gracias por tu compra!</h1>
        <p>De parte de todo el equipo de <strong>King Vape</strong> queremos agradecerte por tu confianza</p>
        <p>Tu satisfacción es y siempre será nuestra prioridad</p>
        <p>Con esto presente, nos encantaría hacerte unas cuantas preguntas para trabajar en mejorar aún más nuestros productos y servicios</p>
        <div style="display: flex; align-items: center; justify-content: center; width: 100%; margin-bottom: 40px; margin-top: 40px;">
          <v-icon @click="toggleDarkMode()" class="rotate-icon" style="margin-right: 15px;">{{ theme.global.name.value == 'light' ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
          <v-divider></v-divider>
        </div>
        <h4 style="margin-bottom: 15px;">¿Cómo calificas la calidad de nuestra atención por medio de WhatsApp (siendo 5 la mejor calificación)?</h4>
        <v-select 
          v-model="input.CRMWhatsappConversationFeedbackOne"
          :items="[5,4,3,2,1]" 
          variant="solo-filled" 
          density="compact"
          hide-details
          clearable
          style="margin-bottom: 5px;"
        >
        </v-select>
        <v-rating
          hover
          :length="5"
          :size="30"
          v-model="input.CRMWhatsappConversationFeedbackOne"
          style="margin-bottom: 40px;"
        />
        <h4 style="margin-bottom: 15px;">¿Cómo calificas la velocidad de respuesta de nuestra atención por medio de WhatsApp (siendo 5 la mejor calificación)?</h4>
        <v-select 
          v-model="input.CRMWhatsappConversationFeedbackTwo" 
          :items="[5,4,3,2,1]" 
          variant="solo-filled" 
          density="compact"
          hide-details
          clearable
          style="margin-bottom: 5px;"
        >
        </v-select>
        <v-rating
          hover
          :length="5"
          :size="30"
          v-model="input.CRMWhatsappConversationFeedbackTwo"
          style="margin-bottom: 40px;"
        />
        <h4 style="margin-bottom: 15px;">¿Cómo calificas la calidad de nuestros productos (siendo 5 la mejor calificación)?</h4>
        <v-select 
          v-model="input.CRMWhatsappConversationFeedbackThree" 
          :items="[5,4,3,2,1]" 
          variant="solo-filled" 
          density="compact"
          hide-details
          clearable
          style="margin-bottom: 5px;"
        >
        </v-select>
        <v-rating
          hover
          :length="5"
          :size="30"
          v-model="input.CRMWhatsappConversationFeedbackThree"
          style="margin-bottom: 40px;"
        />
        <h4 style="margin-bottom: 15px;">¿Qué tan probable es que recomiendes a un familiar o amigo a comprar en King Vape (siendo 5 la mayor probabilidad)?</h4>
        <v-select 
          v-model="input.CRMWhatsappConversationFeedbackFour" 
          :items="[5,4,3,2,1]" 
          variant="solo-filled" 
          density="compact"
          hide-details
          clearable
          style="margin-bottom: 5px;"
        >
        </v-select>
        <v-rating
          hover
          :length="5"
          :size="30"
          v-model="input.CRMWhatsappConversationFeedbackFour"
          style="margin-bottom: 40px;"
        />
        <h4 style="margin-bottom: 15px;">¿Cómo te enteraste de nosotros?</h4>
        <v-select 
          v-model="input.CRMWhatsappConversationFeedbackFive" 
          :items="['Localidad física', 'Recomendación de un familiar o amigo', 'TikTok', 'Buscador de Google', 'Google Maps o Waze', 'Otro']" 
          variant="solo-filled" 
          density="compact"
          hide-details
          clearable
          style="margin-bottom: 40px;"
        >
        </v-select>
        <h4 style="margin-bottom: 15px;">¿Te gustaría compartir alguna sugerencia o recomendación adicional?</h4>
        <v-textarea 
          v-model="input.CRMWhatsappConversationFeedbackSix" 
          variant="solo-filled" 
          density="compact"
          rows="4"
          max-rows="10"
          auto-grow
          hide-details
          clearable
          style="margin-bottom: 40px;"
        >
        </v-textarea>
        <v-card color="indigo" style="padding: 10px; margin-bottom: 40px;">
          <div style="display: flex; align-items: center; justify-content: center; width: 100%; gap: 10px;">
            <v-icon>mdi-star</v-icon>
            <h4 style="margin: 0; text-align: center;">¿Qué otro producto te gustaría que <strong>King Vape</strong> ofrezca?</h4>
            <v-icon>mdi-star</v-icon>
          </div>
          <p style="margin-bottom: 10px;">(<strong>NO</strong> relacionado a vaporizadores)</p>

          <v-select
            v-model="input.CRMWhatsappConversationFeedbackSeven"
            :items="['Perfumes', 'Productos de belleza', 'Accesorios de mascotas', 'Tecnología']"
            variant="solo-filled"
            density="compact"
            hide-details
            clearable
          >
          </v-select>
        </v-card>

        <v-btn @click="generateCRMWhatsappConversationFeedback()" color="primary" block>
          <v-icon style="margin-right: 10px;">mdi-message-fast</v-icon>
          <h3>COMPARTIR FEEDBACK</h3>
        </v-btn>
        <v-divider style="margin-top: 40px; margin-bottom: 40px;"></v-divider>
        <p style="font-size: xx-small;">Al compartir tu feedback, autorizas a <strong>King Vape</strong> para que el mismo pueda ser utilizado para mejorar nuestros productos y servicios</p>
        <p style="font-size: x-small;">Desarrollado por <strong>Souq Systems</strong></p>
        <img 
          :src="require('@/assets/images/KingVapeLogo.png')" 
          alt="King Vape" 
          draggable="false" 
          style="width: 100px; height: auto; margin-top: 10px;"
          :style="theme.global.name.value == 'dark' ? 'filter: invert(1);' : ''"
        >
        <div style="display: flex; justify-content: center; align-items: center; gap: 10px; margin-top: 10px;">
          <a href="https://kingvapecr.com" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/webLogo.png')" alt="Web" draggable="false" style="width: 25px; height: auto;"></a>
          <a href="https://wa.me/50683545548" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/whatsappLogo.png')" alt="WhatsApp" draggable="false" style="width: 25px; height: auto;"></a>
          <a href="https://www.instagram.com/thekingscr_" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/instagramLogo.png')" alt="Instagram" draggable="false" style="width: 25px; height: auto;"></a>
          <a href="https://www.tiktok.com/@kingvape_cr" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/tiktokLogo.png')" alt="TikTok" draggable="false" style="width: 25px; height: auto;"></a>
          <a href="https://www.youtube.com/@KingVapeCR" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/youtubeLogo.png')" alt="Youtube" draggable="false" style="width: 25px; height: auto;"></a>
          <a href="https://www.facebook.com/profile.php?id=100056583533596&locale=es_LA" target="_blank" class="hoverableElement"><img :src="require('@/assets/images/facebookLogo.png')" alt="Facebook" draggable="false" style="width: 25px; height: auto;"></a>
        </div>
      </div>
    </div>
  </v-card>
</template>

<style scoped>
  @keyframes rotate {
    0% {transform: rotate(0deg)}
    100% {transform: rotate(360deg)}
  }
  .rotate-icon {
    animation: rotate 3s linear infinite;
    cursor: pointer;  
  }
</style>

<script setup>
  import { useTheme } from 'vuetify'
  const theme = useTheme();
  const storedTheme = localStorage.getItem('theme');
  theme.global.name.value = storedTheme || 'light';
  function toggleDarkMode(){
    const newTheme = theme.global.name.value == 'dark' ? 'light' : 'dark';
    theme.global.name.value = newTheme;
    localStorage.setItem('theme', newTheme);
  }
</script>

<script>

  export default {
    inject: ['$generalFunctions'],
    components: {},
    data: () => 
    ({
      input: 
      {
        CRMWhatsappConversationFeedbackOne: null,
        CRMWhatsappConversationFeedbackTwo: null,
        CRMWhatsappConversationFeedbackThree: null,
        CRMWhatsappConversationFeedbackFour: null,
        CRMWhatsappConversationFeedbackFive: null,
        CRMWhatsappConversationFeedbackSix: null,
        CRMWhatsappConversationFeedbackSeven: null
      },
      navigation: 
      {
        CRMWhatsappConversationError: false,
        CRMWhatsappConversationFeedbackGenerated: false,
        CRMWhatsappConversationFeedbackCRMWhatsappConversationID: null
      },
      loader: 
      {
        selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView: false,
        generateCRMWhatsappConversationFeedback: false
      },
    }),

    methods:
    {
      async selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView() {
        this.loader.selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView = true;
        const selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackViewRequestQuery =
        {
          'localStorage':
          {
            'CRMWhatsappConversationFeedbackCRMWhatsappConversationID': this.navigation.CRMWhatsappConversationFeedbackCRMWhatsappConversationID
          }
        };
        const selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationFeedback/functions/selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView', selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackViewRequestQuery);
        if (selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackViewResult.success) {
          this.navigation.CRMWhatsappConversationError = selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackViewResult.result == null;
          this.navigation.CRMWhatsappConversationFeedbackGenerated = selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackViewResult.result;
          this.loader.selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView_error', 'error', 'Ha ocurrido un error inesperado al consultar la información del feedback, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },
      
      async generateCRMWhatsappConversationFeedback() {
        if (this.validateInputForCRMWhatsappConversationFeedback(true).success) {
          this.loader.generateCRMWhatsappConversationFeedback = true;
          const generateCRMWhatsappConversationFeedbackRequestQuery =
          {
            'localStorage': 
            {
              'CRMWhatsappConversationFeedbackCRMWhatsappConversationID': this.navigation.CRMWhatsappConversationFeedbackCRMWhatsappConversationID
            },
            'CRMWhatsappConversationFeedbackOne': this.input.CRMWhatsappConversationFeedbackOne,
            'CRMWhatsappConversationFeedbackTwo': this.input.CRMWhatsappConversationFeedbackTwo,
            'CRMWhatsappConversationFeedbackThree': this.input.CRMWhatsappConversationFeedbackThree,
            'CRMWhatsappConversationFeedbackFour': this.input.CRMWhatsappConversationFeedbackFour,
            'CRMWhatsappConversationFeedbackFive': this.input.CRMWhatsappConversationFeedbackFive,
            'CRMWhatsappConversationFeedbackSix': this.input.CRMWhatsappConversationFeedbackSix,
            'CRMWhatsappConversationFeedbackSeven': this.input.CRMWhatsappConversationFeedbackSeven
          };
          const generateCRMWhatsappConversationFeedbackResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationFeedback/functions/generateCRMWhatsappConversationFeedback', generateCRMWhatsappConversationFeedbackRequestQuery);
          if (generateCRMWhatsappConversationFeedbackResult.success) {
            this.navigation.CRMWhatsappConversationFeedbackGenerated = true;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_generateCRMWhatsappConversationFeedback_error', 'error', 'Ha ocurrido un error inesperado al compartir el feedback, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
          this.loader.generateCRMWhatsappConversationFeedback = false;
        }
      },

      validateInputForCRMWhatsappConversationFeedback(showSystemNotificationDialog) {
        if (this.input.CRMWhatsappConversationFeedbackOne == null || ![5,4,3,2,1].includes(this.input.CRMWhatsappConversationFeedbackOne)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_validateInputForCRMWhatsappConversationFeedback_missingCRMWhatsappConversationFeedbackOne', 'info', 'Por favor, completa la primera pregunta para compartir tu feedback', null, false);
          return {success: false, result: 'Por favor, completa la primera pregunta para compartir tu feedback'};
        }
        else if (this.input.CRMWhatsappConversationFeedbackTwo == null || ![5,4,3,2,1].includes(this.input.CRMWhatsappConversationFeedbackTwo)) {
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_validateInputForCRMWhatsappConversationFeedback_missingCRMWhatsappConversationFeedbackTwo', 'info', 'Por favor, completa la segunda pregunta para compartir tu feedback', null, false);
          return {success: false, result: 'Por favor, completa la segunda pregunta para compartir tu feedback'};
        }
        else if (this.input.CRMWhatsappConversationFeedbackThree == null || ![5,4,3,2,1].includes(this.input.CRMWhatsappConversationFeedbackThree)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_validateInputForCRMWhatsappConversationFeedback_missingCRMWhatsappConversationFeedbackThree', 'info', 'Por favor, completa la tercera pregunta para compartir tu feedback', null, false);
          return {success: false, result: 'Por favor, completa la tercera pregunta para compartir tu feedback'};
        }
        else if (this.input.CRMWhatsappConversationFeedbackFour == null || ![5,4,3,2,1].includes(this.input.CRMWhatsappConversationFeedbackFour)) {
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_validateInputForCRMWhatsappConversationFeedback_missingCRMWhatsappConversationFeedbackFour', 'info', 'Por favor, completa la cuarta pregunta para compartir tu feedback', null, false);
          return {success: false, result: 'Por favor, completa la cuarta pregunta para compartir tu feedback'};
        }
        else if (this.input.CRMWhatsappConversationFeedbackFive == null || !['Localidad física', 'Recomendación de un familiar o amigo', 'TikTok', 'Buscador de Google', 'Google Maps o Waze', 'Otro'].includes(this.input.CRMWhatsappConversationFeedbackFive)) {
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_validateInputForCRMWhatsappConversationFeedback_missingCRMWhatsappConversationFeedbackFive', 'info', 'Por favor, completa la quinta pregunta para compartir tu feedback', null, false);
          return {success: false, result: 'Por favor, completa la quinta pregunta para compartir tu feedback'};
        }
        else if (this.input.CRMWhatsappConversationFeedbackSix != null && this.input.CRMWhatsappConversationFeedbackSix.length > 65535) {
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_validateInputForCRMWhatsappConversationFeedback_CRMWhatsappConversationFeedbackSixTooLong', 'info', 'Por favor, escribe una sugerencia o recomendación adicional que no exceda los 65535 caracteres', null, false);
          return {success: false, result: 'Por favor, escribe una sugerencia o recomendación adicional que no exceda los 65535 caracteres'};
        }
        else if (this.input.CRMWhatsappConversationFeedbackSeven != null && this.input.CRMWhatsappConversationFeedbackSeven.length > 65535) {
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationFeedbackView_validateInputForCRMWhatsappConversationFeedback_CRMWhatsappConversationFeedbackSevenTooLong', 'info', 'Por favor, escribe un producto que te gustaría que <strong>King Vape</strong> ofrezca que no exceda los 65535 caracteres', null, false);
          return {success: false, result: 'Por favor, escribe un producto de sugerencia que no exceda los 65535 caracteres'};
        }
        return {success: true, result: null};
      }
    },

    async mounted(){
      this.navigation.CRMWhatsappConversationError = false;
      this.navigation.CRMWhatsappConversationFeedbackGenerated = false;
      this.navigation.CRMWhatsappConversationFeedbackCRMWhatsappConversationID = null;
      this.loader.selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView = false;
      this.loader.generateCRMWhatsappConversationFeedback = false;
      this.navigation.CRMWhatsappConversationFeedbackCRMWhatsappConversationID = this.$route.params.CRMWhatsappConversationFeedbackCRMWhatsappConversationID;
      this.selectCRMWhatsappConversationFeedbackFromCRMWhatsappConversationFeedbackView();
    },

    beforeUnmount(){}
  }
</script>